<template>
    <b-table-simple hover small caption-top responsive>
        <caption>
            <h5 style="display: inline-block">Перечень услуг для выставления счета</h5>
            <button 
                type="button" 
                class="btn btn-primary text-right ml-2 mb-2" 
                size="sm" 
                @click="addService()"
            >
                <b-icon icon="plus" font-scale="1.2"></b-icon>
            </button>
            <button
                type="button"
                class="btn btn-secondary text-right ml-2 mb-2 pr-2"
                size="sm"
                @click="toggleTurning()"
            >
                Перевыставление
                <b-icon
                    v-if="editedItem.turning >= 0 && editedItem.turning != null"
                    icon="x"
                    size="1.2"
                    variant="light"
                ></b-icon>
            </button>
            <button
                v-if="showTOMagicButton"
                type="button"
                class="btn btn-secondary text-right ml-2 mb-2"
                size="sm"
                @click="addService({name: 'Оформление дополнительных листов к ДТ'})"
            >
                Доп.лист
            </button>
        </caption>
        <b-thead v-if="servicesList.length > 0">
            <b-tr>
                <b-th class="text-center" style="width: 5%;">№</b-th>
                <b-th>Услуга</b-th>
                <b-th style="width: 7%;">Кол-во</b-th>
                <b-th style="width: 15%;">Цена</b-th>
                <b-th style="width: 15%;">Стоимость</b-th>
                <b-th class="text-center" style="width: 10%;">Действие</b-th>
            </b-tr>
        </b-thead>
        <b-tbody v-if="servicesList.length > 0">
            <b-tr v-for="(service, index) in servicesList" :key="`service_${index}`">
                <b-td class="text-center align-middle">{{ service.id }}</b-td>
                <b-td class="align-middle">
                    <b-form-textarea
                        v-model="service.name"
                        size="sm"
                        placeholder="Введите наименование услуги"
                        rows="2"
                        max-rows="6"
                    ></b-form-textarea>
                </b-td>
                <b-td class="align-middle">
                    <b-form-input 
                        size="sm" 
                        type="number" 
                        min="1" 
                        max="999999" 
                        v-model="service.number" 
                        @input="calculateTotal()"
                    ></b-form-input>
                </b-td>
                <b-td class="align-middle">
                    <b-form-input 
                        size="sm" 
                        type="text"
                        v-model="service.sum" 
                        @keyup="changeCommasOnDots($event)"
                        @input="calculateTotal()"
                    ></b-form-input>
                </b-td>
                <b-td class="align-middle">{{ (Number(service.number ? service.number : 1) * service.sum) }}</b-td>
                <b-td class="text-center align-middle">
                    <button 
                        type="button" 
                        class="btn btn-danger text-right" 
                        size="sm" 
                        @click="removeService(index)"
                    >
                        <b-icon icon="x" font-scale="1.2"></b-icon>
                    </button>
                </b-td>
            </b-tr>
        </b-tbody>
    </b-table-simple>    
</template>

<script>
import {
    changeCommasOnDots
} from '@/mixins';

export default {
    name: 'OtherServicesList',
    props: {
        servicesList: Array,
        editedItem: Object,
        showTOMagicButton: Boolean
    },
    mixins: [
        changeCommasOnDots,
    ],
    methods: {
        addService(data = {}) {
            this.$emit('addService', {
                id: this.servicesList.length + 1,
                name: (data.name ? data.name : ''),
                number: (data.number ? data.number : 1),
                sum: (data.sum ? data.sum : 0),
            });

            this.$emit('recalculate');
        },
        removeService(index) {
            this.$emit('removeService', index);
            this.$emit('recalculate');
        },
        calculateTotal() {
            this.$emit('recalculate');
        },
        toggleTurning() {
            this.$emit('toggleTurning');
        }
    },
};
</script>
